export const GET_USERS = 'get_users';
export const DEACTIVATE_USER_DATA = 'deactivate_user_data';
export const ADD_USER_DATA = 'add_user_data';
export const UPDATE_USER_DATA = 'update_user_data';
export const ACTIVATE_USER_DATA = 'activate_user_data';
export const LOCK_USER_DATA = 'lock_user_data';
export const GET_NEW_DISTRIBUTOR_LIST = 'get_new_distributor_list';
export const GET_NEW_DISTRIBUTOR_LIST_REQUEST = 'get_new_distributor_list_request';
export const GET_NEW_DISTRIBUTOR_LIST_FAILURE = 'get_new_distributor_list_failure';
export const GET_PARTNERS_LIST = 'get_partners_list';
